import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { createPersonalTraining } from '../services/trainingsService';
import { FormattedMessage } from 'react-intl';
import Dialog from '../../../components/Dialog';
import PersonalTrainingForm from './PersonalTrainingForm';

// ----------------------------------------------------------------------

export default function NewUserDialog({ onClose, ...dialogProps }) {
  const { enqueueSnackbar } = useSnackbar();


  const handlePersonalTrainingCreate = async (values, actions) => {
    try {
      const updatedValues = {
        ...values,
        participants: values.participants.map(participant => participant.id)
      };
      await createPersonalTraining(updatedValues);
      enqueueSnackbar(<FormattedMessage id='newTraining.create.msg.success' defaultMessage='Training successfully created' />, {
        variant: 'success',
      });
      onClose(true);
    } catch (error) {
      enqueueSnackbar(<FormattedMessage id='newTraining.create.msg.error' defaultMessage='Create training failed' />, {
        variant: 'error',
      });
      actions.setSubmitting(false);
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      {...dialogProps}
      onClose={handleClose}
      title={<FormattedMessage id='newTraining.title' defaultMessage='Create Training' />}
    >
      <PersonalTrainingForm
        onSubmit={handlePersonalTrainingCreate}
      />
    </Dialog>
  );
}

NewUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
